import React from 'react';

// const TypingIndicator = ({ active }) => (
//   <div className='mc-chat-typing'>{!!active ? 'typing...' : ''}</div>
// );

const TypingIndicator = ({ active }) => {
  // active = true;
  if (!active) return null;
  return (
    <div className='mc-chat-typing2'>
      {/*<div class='dot-elastic'></div>*/}
      {/*<div class='dot-falling'></div>*/}
      <div className='dot-pulse'></div>
    </div>
  );
};

export default TypingIndicator;
